module.exports = __webpack_public_path__ + "static/media/icon_tabulation_r.6043c09b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icon/icon_tabulation_r.svg
// module id = 634
// module chunks = 0